// extracted by mini-css-extract-plugin
module.exports = {"button":"TextButton_button__05JCA","regularText":"TextButton_regularText__0cf33","startIcon":"TextButton_startIcon__90JkZ"};